import Sendmail from './Sendmail'

import { connect } from 'react-redux'

import actions from '../../../../../../../store/actions'

export default connect(null, dispatch => ({
  upload: (file, opts) => dispatch(actions.library.upload(file, opts))
}))(Sendmail)
